<template>
    <!-- <div class="carousel slide" data-bs-ride="carousel" data-bs-interval="false"> -->
    <!-- <div class="carousel slide carousel-fade1"> -->
    <div class="carousel slide carousel-fade carousel2" :data-bs-ride="data.length ? 'carousel' : 'ride'" data-bs-touch="true" data-bs-pause="hover" data-bs-interval="5000">
		<!-- <ol class="carousel-indicators">
            <template v-for="(item, index) in data" :key="index">
                <li data-bs-target="#carousel" :id="item.id" :data-bs-slide-to="index" :class="index == 0 ? 'active' : ''" aria-current="true" aria-label="Slide 1"></li>
            </template>
        </ol> -->

        <div v-if="data.length > 1" class="carousel-indicators">
            <template v-for="(item, index) in data" :key="index">
                <button type="button" data-bs-target=".carousel2" :data-bs-slide-to="index" :class="index == 0 ? 'active' : ''" aria-current="true" :aria-label="`Slide${item.id}`"></button>
            </template>
        </div>

		<div class="carousel-inner h-100">

            <template v-for="(item, index) in data" :key="index">
                <div class="carousel-item" :class="index == 0 ? 'active' : ''">
                <!-- <div class="carousel-item" :class="index == 0 ? 'active' : ''" data-bs-interval="2000"> -->
                    <!-- <div class="overlay"></div> -->
                    <!-- <div class="carousel-bg" :style="`background-image: url('${item.image}');`"></div> -->

                    <a :href="item.link || 'javascript:void(0)'" :target="item.link != '' ? 'blank' : ''" class="d-block h-100">
                        <slot name="body" :item="item">
                            <div class="row h-100">
                                <div v-if="showCaption" class="col-sm-3 m-0 p-0">
                                    <div class="carousel-caption1 d-none1 d-sm-block">
                                        <h4 class="mb-3" v-html="item.title"></h4>
                                        <!-- <h2>{{item.date}}</h2> -->
                                        <p v-html="item.content"></p>
                                    </div>
                                </div>

                                <!-- <div :class="(showCaption ? 'col-sm-12' : 'col-sm-9') + ' m-0 p-0'">
                                    <img :src="item.image" class="d-block h-100" alt="..." />
                                </div> -->

                                <div v-if="item.type == 'video'" :class="(showCaption ? 'col-sm-12' : 'col-sm-9') + ' m-0 p-0 video-container'">
                                    <video :src="item.image" autoplay muted loop></video>
                                </div>
                                <div v-else-if="item.type == 'youtube'" :class="(showCaption ? 'col-sm-12' : 'col-sm-9') + ' m-0 p-0 video-container'">
                                    <iframe :src="item.image" frameborder="0" allow="accelerometer; autoplay; modestbranding; encrypted-media; gyroscope; picture-in-picture" ></iframe>
                                </div>
                                <div v-else :class="(showCaption ? 'col-sm-12' : 'col-sm-9') + ' m-0 p-0'">
                                    <div class="carousel-bg" :style="`background: url(${item.image}) no-repeat; background-size: cover; background-position: right;`"></div>
                                </div>
                            </div>
                        </slot>
                    </a>
                </div>
            </template>

		</div>

        <template v-if="showNav && data.length > 1">
            <button
                class="carousel-control-prev"
                type="button"
                data-bs-target=".carousel2"
                data-bs-slide="prev"
            >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button
                class="carousel-control-next"
                type="button"
                data-bs-target=".carousel2"
                data-bs-slide="next"
            >
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </template>

	</div>
</template>


<script>
export default {
    name: "Carousel2C",
    props: {
        data: {
            type: Array,
            default: () => []
        },
        showCaption: {
            type: Boolean,
            default: true
        },
        showNav: {
            type: Boolean,
            default: true
        },
    },
    setup() {
        return {};
    },
}
</script>


<style lang="scss">
.carousel{
    // height: 550px;
}
.carousel-caption1 {
    right: unset;
    left: unset;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-image: linear-gradient(-30deg, #261a52, rgb(115, 5, 5), rgb(160, 63, 8));
    color: #ffffff;
    padding: 40px;
    // background-image: linear-gradient(
    //     -90deg,
    //     rgba(189, 189, 189, 0.8),
    //     rgba(0, 118, 189, 0.8),
    //     transparent 100%
    // );
}
.carousel-item{
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.carousel-control-prev{
    justify-content: start;
}
.carousel-control-next{
    justify-content: end;
}
.carousel-control-next, .carousel-control-prev{
    width: 10%;
}
.carousel-control-prev-icon, .carousel-control-next-icon{
    background-color: #cdcdcd50;
    padding: 30px;
    border-radius: 5%;
    background-size: 60%;
}
.carousel-indicators [data-bs-target]{
    width: 15px;
    height: 15px;
    border-radius: 50%;
}
.video-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: -999;

    overflow: hidden;
    pointer-events: none;
    aspect-ratio: 16/9;
}
.video-container iframe, .video-container video{
    // height: calc(100vh - 400px);
    background-color: #000000;
    height: 100%;
    width: 100%;
    border: 0px;
    pointer-events: none;
}
.carousel-bg {
    // height: calc(100vh - 100px);
    height: 100%;
    // background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
}

@media (max-width: 576px){
    .carousel, .carousel-item{
        height: auto;
    }
    .carousel-item{
        // background-size: contain;
        height: auto !important;
        // height: 100px !important;
        // height: 200px;
        width: 100%;
    }
    .carousel-caption, .carousel-caption h2{
        // font-size: 9pt;
        font-size: calc(var(--bs-body-font-size) * 8);
        bottom: .5rem;
        padding-top: .5rem;
        padding-bottom: .5rem;
    }
    .carousel-control-prev-icon, .carousel-control-next-icon{
        padding: 5px;
    }
}
</style>
